import {Component, ElementRef, Inject, NgZone, OnInit, ViewChild} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';

import ZoomMtgEmbedded, {CustomSize, EmbeddedClient, SuspensionViewType, VideoPopperStyle} from '@zoom/meetingsdk/embedded';
import {HttpClient} from '@angular/common/http';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'zoom-page',
    templateUrl: './zoom.page.html',
    styleUrls: ['./zoom.page.scss']
})

export class ZoomPage implements OnInit {

    authEndpoint = 'http://localhost:4000'
    sdkKey = 'FOnBArNTSJ63lWiP75YKGw'
    meetingNumber = '4648858931'
    passWord = '973562'
    role = 0
    userName = 'Test User'
    userEmail = 'test@user.com'
    registrantToken = ''
    zakToken = ''
    leaveUrl = 'http://localhost:4200'

    client = null
    shareScreen = true

    @ViewChild('meetingSDKElement', { static: false }) meetingSDKElement!: ElementRef;
    @ViewChild('meetingSDKChatElement', { static: false }) meetingSDKChatElement!: ElementRef;

    constructor(
        public httpClient: HttpClient, @Inject(DOCUMENT) document, private ngZone: NgZone
    ) {
    }

    ngOnInit() {
    }

    getSignature() {
        this.httpClient.post(this.authEndpoint, {
            meetingNumber: this.meetingNumber,
            role: this.role
        }).subscribe((data: any) => {
            if(data.signature) {
                console.log(data.signature)
                this.startMeeting(data.signature)
            } else {
                console.log(data)
            }
        })
    }

    startMeeting(signature) {

        let meetingSDKChatElement = document.getElementById('meetingSDKChatElement')

        // document.getElementById('zmmtg-root').style.display = 'block'

        this.ngZone.runOutsideAngular(() => {
            this.client = ZoomMtgEmbedded.createClient()

            this.client.init({
                debug: true,
                zoomAppRoot: this.meetingSDKElement.nativeElement,
                language: 'en-US',
                patchJsMedia: true,
                leaveOnPageUnload: true,
                customize: {
                    video: {
                        popper: {
                            disableDraggable: false,
                        },
                        isResizable: false,
                        viewSizes: {
                            ribbon: {
                                width: 240,
                                height: 135
                            },
                            default: {
                                width: 240,
                                height: 135
                            }
                        },
                        defaultViewType: SuspensionViewType.Speaker,
                        /** Minimized = 'minimized',
                         Speaker = 'speaker',
                         Ribbon = 'ribbon',
                         Gallery = 'gallery',
                         Active = 'active' */
                    },
                    // meeting: {
                    //     popper: {
                    //         disableDraggable: false,
                    //         anchorElement: this.meetingSDKChatElement.nativeElement,
                    //         placement: 'top'
                    //     }
                    // },
                    chat: {
                        popper: {
                            disableDraggable: false,
                            anchorElement: meetingSDKChatElement,
                            placement: 'top'
                        }
                    },
                    // participants: {
                    //     popper: {
                    //         disableDraggable: false,
                    //         anchorElement: this.meetingSDKChatElement.nativeElement,
                    //         placement: 'top'
                    //     }
                    // }
                }
            }).then((res) => {
                console.log('client.init', res)
                this.client.join({
                    signature: signature,
                    sdkKey: this.sdkKey,
                    meetingNumber: this.meetingNumber,
                    password: this.passWord,
                    userName: this.userName,
                    userEmail: this.userEmail,
                    // registrantToken: this.registrantToken,
                    // zakToken: this.zakToken,
                    success: (success) => {
                        console.log('client.join.success', success)
                        console.log(document.getElementsByClassName('zoom-MuiBox-root')[0])
                    },
                    error: (error) => {
                        console.log('client.join.error', error)
                    }
                }).then((res) => {
                    console.log('client.join', res)
                    setTimeout(() => {
                        this.switchViews();
                    }, 1000)
                }).catch((error) => {
                    console.log('client.join.catch', error)
                })
            })
        })
    }

    switchViews() {

        const canvases = document.querySelectorAll('canvas');

        canvases.forEach(canvas => {
            const { width, height } = canvas;
            const classNames = canvas.className;

            if (canvas.getAttribute('aria-label').includes('Screen share')) { // Hypothetical condition
                console.log('This is likely the shared screen canvas:', canvas);
                document.getElementById('host-share-screen-container').appendChild(canvas);
            } else if (canvas.getAttribute('aria-label').includes('Participant')) { // Hypothetical condition
                console.log('This is likely the participants video canvas:', canvas);
                document.getElementById('host-video-container').appendChild(canvas);
                document.getElementById('host-video-container').appendChild(document.getElementsByClassName('css-vv0cdr')[0])

            } else {
                console.log('Unknown canvas:', canvas);
            }

        });

        // document.getElementById('host-toolbar-container').appendChild(document.getElementsByClassName('css-woj72k')[0])


        // const canvasElements = document.getElementsByTagName("canvas")
        // console.log('canvasElements', canvasElements)
        //
        // canvasElements[1].setAttribute('position', 'absolute')

        // const shareElement = document.getElementById('__ZOOM_SDK_SHARE_CANVAS_3316__')
        // console.log('shareElement',shareElement)

        // document.getElementsByClassName('zoom-MuiBox-root')[0].setAttribute('style', 'position: relative;')
        // document.getElementsByClassName('css-17y2x1')[0].classList.toggle('hiddenForced');
        //
        // this.meetingSDKElement.nativeElement.querySelector('div').setAttribute('style', 'width: 100%;')
        //
        // const elements = document.getElementsByClassName('zoom-MuiPaper-root')
        // if (elements.length > 0) {
        //     for (let i = 0; i < elements.length; i++) {
        //         elements[i].setAttribute('style', 'width: 100%;')
        //     }
        // }
        //
        // const buttonElements = document.getElementsByClassName('zoom-MuiButton-root')
        //
        // if (buttonElements.length > 0) {
        //     for (let i = 0; i < buttonElements.length; i++) {
        //         buttonElements[i].classList.toggle('hiddenForced');
        //     }
        // }

        //zoom-MuiPaper-root zoom-MuiPaper-elevation zoom-MuiPaper-rounded zoom-MuiPaper-elevation1 css-ip80nc



    }

}
